let languageStore = {
    current : 'en'
};

export function set(_language) {
    languageStore.current = _language;
}

export function get() {
    return languageStore.current;
}
